// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  padding: 0 12px;
  --background: #fff;
}
ion-toolbar ion-icon {
  height: 22px;
  width: 22px;
}
ion-toolbar ion-title {
  font-family: AppFontMedium;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.44px;
  text-align: left;
  color: #785526;
}
ion-toolbar ion-icon {
  color: #785526;
  fill: #785526;
}`, "",{"version":3,"sources":["webpack://./src/app/components/account-toolbar/account-toolbar.component.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,kBAAA;AACD;AAAC;EACC,YAAA;EACA,WAAA;AAEF;AAAC;EACC,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;AAEF;AACC;EACC,cAAA;EACA,aAAA;AACF","sourcesContent":["ion-toolbar {\n\tpadding: 0 12px;\n\t--background: #fff;\n\tion-icon {\n\t\theight: 22px;\n\t\twidth: 22px;\n\t}\n\tion-title {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\t\tline-height: 19.44px;\n\t\ttext-align: left;\n\t\tcolor: #785526;\n\t}\n\n\tion-icon {\n\t\tcolor: #785526;\n\t\tfill: #785526;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
